import React, { PropTypes } from 'react';
import { Link, IndexLink, browserHistory } from 'react-router';
import './Message.scss';

class Message extends React.Component {
    constructor(props) {
        super(props);
        // this.chooseUser = this.chooseUser.bind(this);
    }

    render() {
        const {message} = this.props;

        function formatDateAndTime(time) {
            var date = new Date(time);
            return date.toLocaleString();
        }

        return (
            <div className="message-container">
                <div className="date">
                    {formatDateAndTime(message.date)}
                </div>
                <div className="message">
                    <div className="user-first-name">{message.user.userName.first}</div>
                    <div className="text">{message.text}</div>
                    <div> </div>
                </div>
            </div>
        );
    }
}

export default Message;



/** WEBPACK FOOTER **
 ** ./src/components/Message/Message.js
 **/